import React from 'react';
import PropTypes from 'prop-types';
import IropsItinearyCards from './irops-itinerary-cards';
import TranslatedCopy from '../../intl/translated-copy';
import { REFUND_URL } from '../../constants/urls';
function IropsCancelCards({
  allDestinationInfo,
  country,
  flightTime,
  language,
  operationalWindowStatus,
  pnrModel,
  tripType,
}) {
  const trip = tripType;
  const isMultiCity = pnrModel?.isMulticity();
  const isRoundTrip = !isMultiCity && trip === 'ROUNDTRIP';
  const isOneWay = !isMultiCity && trip === 'ONEWAY';
  const legsCancelled = pnrModel?.getLegsCancelled();

  return (
    <>
      <div className='iropsatc-conetnt-header'>
        <TranslatedCopy
          className='iropsatc-header-message'
          copyID='MYB_RESERVATION_FOUND'
          tagName='p'
        />
      </div>
      <div className='itinerary-cards-list cards-cancel'>
        <div className='itinerary-tag-master'>
          <div className='tag-master-container flight-cancel'>
            <TranslatedCopy
              className='iropsatc-tag-message'
              copyID='MYB_CANCELED'
            />
            <span className='ItineraryCard-status-hour' />
          </div>
        </div>
        { legsCancelled?.map((legModel, index) => {
          return (
            <IropsItinearyCards
              allDestinationInfo={ allDestinationInfo }
              country={ country }
              flightTime={ flightTime }
              isOneWay={ isOneWay }
              isRoundTrip={ isRoundTrip }
              iteration={ index }
              itineraryPartType={ legModel?.itineraryPartType }
              language={ language }
              legIndex={ index }
              legModel={ legModel }
              tripTag={ 1 }
            />);
        }) }
        { operationalWindowStatus &&
          <div className='itinerary-refund-container'>
            <div className='refund-text-container'>
              <TranslatedCopy
                className='itinerary-affects-text'
                copyID='MYB_THE_CHANGE_IN_ITINERARY_AFFECTS_ALL_PASSENGERS'
              />
              <div>
                <TranslatedCopy copyID='MYB_IF_REQUIRE_A_REFUND_REQUEST_IT'/>
                <TranslatedCopy
                  className='myb-here-text'
                  copyID='MYB_HERE'
                  onClick={ () => window.open(REFUND_URL, '_blank') }
                />
              </div>
            </div>
          </div>
        }
      </div>
      <div className='ontime-space-container'></div>
    </>
  );
}

IropsCancelCards.propTypes = {
  allDestinationInfo: PropTypes.object,
  country: PropTypes.string,
  flightStatus: PropTypes.string,
  flightTime: PropTypes.string,
  language: PropTypes.string,
  pnrModel: PropTypes.object,
  tripType: PropTypes.number,
};

IropsCancelCards.defaultProps = {
  allDestinationInfo: {},
  country: '',
  flightStatus: '',
  flightTime: '',
  language: '',
  pnrModel: {},
  tripType: null,
};

export default IropsCancelCards;